import { Component, OnInit } from '@angular/core';
import { AuthService, FormErrors, ConfirmForm } from "../login/auth.service";
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmPage implements OnInit {

  public form: ConfirmForm = new ConfirmForm
  public errors: FormErrors = new FormErrors
  public result: boolean

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    let hash = this.route.snapshot.paramMap.get('hash');
    this.form.hash = hash;
    this.authService.confirm(this.form).then(res => {
        this.result = true;
        // this.router.navigate([this.authService.getAuth().isAdmin() ? 'admin' : 'dashboard']);
      }, err => {
          this.result = false;
      });
  }

   public authorized() {
    return this.authService.getAuth().isAuthorized();
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/confirm/confirm.component.ts